// Checkbox.jsx - Custom checkbox component matching Figma design
import React from 'react';
import { Check } from 'lucide-react';

// Exported from the Figma auth flow (iconamoon:attention-circle-fill), 24x24.
const ATTENTION_ICON = '/assets/icons/attention-circle-fill.svg';

const Checkbox = ({
  checked,
  onChange,
  label,
  name,
  id,
  required = false,
  disabled = false,
  error,
  className = '',
  ...props
}) => {
  const checkboxId = id || name || 'checkbox';

  return (
    // Column, not a row: the error belongs under the checkbox, not beside it.
    // As a sibling of the label it used to land on the same line and shove the
    // label sideways. 20px is the gap the design leaves between the two.
    <div className={`flex flex-col gap-[20px] ${className}`}>
      {/* items-center so the box sits on the text's centre line, not its top. */}
      <div className="flex items-center gap-[8px]">
        <div className="relative flex-shrink-0">
          <input
            type="checkbox"
            id={checkboxId}
            name={name}
            checked={checked}
            onChange={onChange}
            required={required}
            disabled={disabled}
            aria-invalid={error ? 'true' : 'false'}
            aria-describedby={error ? `${checkboxId}-error` : undefined}
            className="sr-only"
            {...props}
          />
          <label
            htmlFor={checkboxId}
            className={`block h-[18px] w-[18px] rounded-[5px] border ${
              checked
                ? 'border-bloom-green bg-bloom-green/10'
                : 'border-[#9CA3AF] bg-white'
            } cursor-pointer transition-colors hover:border-bloom-green ${
              disabled ? 'opacity-50 cursor-not-allowed' : ''
            } ${error ? 'border-[#DC2626]' : ''}`}
          >
            {checked && (
              <Check
                size={14}
                className="text-bloom-green absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
                strokeWidth={3}
              />
            )}
          </label>
        </div>
        {label && (
          <label
            htmlFor={checkboxId}
            className={`text-[14px] font-['Inter'] leading-[1.5] cursor-pointer ${
              disabled ? 'opacity-50 cursor-not-allowed' : ''
            } text-[#5d625f]`}
          >
            {label}
          </label>
        )}
      </div>
      {error && (
        <p
          id={`${checkboxId}-error`}
          className="flex items-center gap-[8px] text-[14px] text-[#DC2626] font-['Inter']"
          role="alert"
        >
          <img
            src={ATTENTION_ICON}
            alt=""
            width={24}
            height={24}
            className="h-[24px] w-[24px] flex-shrink-0"
          />
          {error}
        </p>
      )}
    </div>
  );
};

export default Checkbox;
